module.exports = __webpack_public_path__ + "img/report-1.b193932a.jpg";